import {useMutation, useQuery, useQueryClient} from "react-query"
import {EnvApi} from "api/env.api"
import {Environment} from "dto/env/env"
import {NotificationType, showNotification} from "common/Notification"
import {AxiosError} from "axios"
import {ApiResponse} from "api/common/response"

export const useFindEnvironment = () => {
    return useQuery("env/find", () => {
        return EnvApi.findEnvironment()
    })
}

export const useUpdateEnvironmentMutation = () => {
    const client = useQueryClient()
    return useMutation(async (env: Environment) => {

        return EnvApi.updateEnvironment(env)
    }, {
        onSuccess: async () => {
            await client.invalidateQueries("env/find")
            showNotification("환경설정이 수정되었습니다", NotificationType.SUCCESS)
        },
        onError: (error, variables, context) => {
            try {
                const err = error as AxiosError<ApiResponse<null>>
                showNotification(err.response?.data?.message || "환경설정 수정중 오류가 발생하였습니다")
            } catch (err) {
                showNotification("환경설정 수정중 오류가 발생하였습니다")
            }
        }
    })
}